module.exports = __webpack_public_path__ + "img/logo.041c2045.svg";